export default __webpack_public_path__ + "static/media/rejected.fe637f0f.svg";